/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import React, { useEffect, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import MMCCancelRequest from "../../components/MMC/MMCCancelRequest";
import MMCApproveList from "../../components/MMC/MMCApproveList";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import DateRange from "../../components/DateRange/DateRange";
import Select from "react-select";
import { Search_icon } from "../../assets/img";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { useLocation } from "react-router-dom";
import ReadNotificationPopup from "../../components/ReadNotificationPopup";
import { toast } from "react-toastify";
import UnReadNotificationPopup from "../../components/UnReadNotificationPopup";

const MMCCancellationList = ({ property_id }) => {
  const { paginationData, setpaginationData } = useGlobalContext();
  const location = useLocation();
  const path = location.pathname?.replace("/", "");
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [pagination, setPagination] = useState({});
  const [selectedOwners, setSelectedOwners] = useState([]);
  const [showSubmitPopup, setShowSubmitPopup] = useState(false);
  const [isViewDetails, setIsViewDetails] = useState({
    ispopUp: false,
    details: {},
  });
  const [submissionDescription, setSubmissionDescription] = useState("");
  const [count, setCount] = useState(0);
  const [selectedFilter, setSelectedFilter] = useState({
    from: paginationData?.[path]?.from ?? "",
    to: paginationData?.[path]?.to ?? "",
    property: property_id ? { value: property_id } : "",
    owner: "",
    search: paginationData?.[path]?.search ?? "",
    unread_only: false,
    search_device: false,
  });
  const [optionsList, setOptionsList] = useState({
    owners: [],
    properties: [],
  });
  const [transactions, setTransactions] = useState({
    requested: [],
    approved: [],
  });

  useEffect(() => {
    getOwnerList();
    getProperties();
  }, []);

  useEffect(() => {
    getList(page);
    setpaginationData((prev) => ({
      ...prev,
      [path]: { ...prev?.[path], page: page, search: selectedFilter.search },
    }));
  }, [
    selectedFilter.owner,
    selectedFilter.property,
    selectedFilter.search,
    selectedFilter.search_device,
    page,
  ]);

  useEffect(() => {
    const { from, to } = selectedFilter;
    if ((from && to) || (!from && !to)) getList(page);
  }, [selectedFilter.from, selectedFilter.to]);

  const [tabs, setTabs] = useState(
    Number(localStorage.getItem("mmcCancelTabs")) || 1,
  );
  useEffect(() => {
    getList(1);
  }, [tabs, selectedFilter?.unread_only]);
  const handleTabChange = (tab) => {
    setPage(1);
    setTabs(tab);
    localStorage.setItem("mmcCancelTabs", tab);
    setSelectedFilter({
      from: "",
      owner: "",
      property: "",
      search: "",
      to: "",
      search_device: "",
    });
  };

  const getList = async (pageNumber = 1) => {
    const { property, from, owner, search, to, unread_only, search_device } =
      selectedFilter;
    const payload = new FormData();
    if (search) {
      payload.append("search", search);
    }
    if ((from && to) || (!from && !to)) {
      payload.append("from_date", from);
      payload.append("to_date", to);
    }
    if (property) {
      payload.append("property", property?.value);
    }
    if (owner) {
      payload.append("owner", owner?.value);
    }
    if (search_device) {
      payload.append("search_device", search_device);
    }
    const res = await post(
      `${URLS.MMC_CANCELLATION_LIST}${
        tabs === 1 ? "requested" : "approved"
      }&page=${pageNumber}&unread_only=${unread_only}`,
      payload,
    );
    console.log("mmc cancellation list", res);
    if (res?.status === "success") {
      setCount(res?.count);
      setPagination({
        current_page: pageNumber,
        last_page: res?.total_pages,
      });
      setTransactions((prev) => ({
        ...prev,
        [tabs === 1 ? "requested" : "approved"]: res?.data,
      }));
    }
  };

  //get properties
  const getProperties = async () => {
    const res = await get(URLS.PROPERTIES_DROPDOWN);
    console.log("properties dropdown", res);
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name };
      });
      setOptionsList((prev) => ({ ...prev, properties: modifiedList }));
    }
  };

  // get owners list
  const getOwnerList = async (search) => {
    console.log("search", search);
    const res = await get(
      `${URLS.OWNERS_DROPDOWN}${search ? "?search=" + search : ""}`,
    );
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name };
      });
      console.log("owner response success", res, modifiedList);
      setOptionsList((prev) => ({ ...prev, owners: modifiedList }));
    }
  };

  const handleChangeFilter = (name, val) => {
    if (name !== "from" && val) setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };
  const handleSumbit = async () => {
    let payload = {
      ids: selectedOwners,
      description: submissionDescription,
    };

    try {
      let url = URLS.NOTIFICATION_COUNTREDUCE;
      let res = await post(url, payload);
      if (res?.status === "success") {
        // console.log("Description:", submissionDescription);
        toast.success("Read Notification has be Success");
        setShowSubmitPopup(false);
        setSubmissionDescription("");
        setSelectedOwners([]);
        getList();
      }
    } catch (error) {
      console.error("Error fetching booking data:", error);
    }
    const res = console.log("Selected Owners:", payload);
  };
  console.log("location?.statelocation?.state", location?.state);
  useEffect(() => {
    if (location?.state?.tab) {
      setTabs(location.state.tab);
    }
  }, [location?.state?.tab]);

  return (
    <div>
      {!property_id && <Topbar header={"MMC"} subHead={"MMC Cancellation"} />}
      <div
        className="d-flex mb-4"
        style={{
          flexDirection: "row",
          alignItems: "center",
          gap: 50,
          // justifyContent: "space-between",
          // width: "100%",
        }}
      >
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total:{count}
        </h2>
        {tabs === 1 && (
          <>
            <div className="d-flex" style={{ alignItems: "center" }}>
              <input
                type="checkbox"
                checked={selectedFilter?.unread_only}
                onChange={() =>
                  handleChangeFilter(
                    "unread_only",
                    !selectedFilter?.unread_only,
                  )
                }
              />{" "}
              <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 ">
                Check New Notification
              </p>
              {/* <Select
            className="location-search"
            options={[{ label: "New to Old", value: "newtoold" }]}
            isClearable
            // onChange={(e) => {
            //   handleChangeFilter("property", e);
            // }}
            // value={selectedFilter?.property}
            placeholder={"property"}
          /> */}
            </div>
          </>
        )}
        <div className="d-flex" style={{ alignItems: "center" }}>
          <input
            type="checkbox"
            checked={selectedFilter?.search_device}
            onChange={() =>
              handleChangeFilter(
                "search_device",
                !selectedFilter?.search_device,
              )
            }
          />
          <p className="f3 ms-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15">
            Check IOS Request
          </p>
        </div>
      </div>
      {/* <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
        Total: {count}
      </h2> */}
      <div className="d-flex ac-js gap-4 mt-4">
        <p
          onClick={() => handleTabChange(1)}
          className={`${
            tabs === 1 ? "prim-btn" : "sec"
          } f4 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 pointer`}
        >
          {" "}
          Request
        </p>
        <p
          onClick={() => handleTabChange(2)}
          className={`${
            tabs === 2 ? "prim-btn" : "sec"
          } f4 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16  ms-4 pointer`}
        >
          Approved
        </p>
      </div>

      <div className="d-flex ac-je mt-3 gap-3 flex-wrap">
        <DateRange
          setFromDate={(date) => {
            handleChangeFilter("from", date);
          }}
          setToDate={(date) => {
            handleChangeFilter("to", date);
          }}
        />
        {!property_id && (
          <Select
            className="location-search"
            options={optionsList?.owners}
            onChange={(e) => {
              handleChangeFilter("owner", e);
            }}
            value={selectedFilter?.owner}
            placeholder={"Owners"}
          />
        )}
        {!property_id && (
          <Select
            className="location-search"
            options={optionsList.properties}
            value={selectedFilter.property}
            onChange={(e) => {
              handleChangeFilter("property", e);
            }}
            placeholder={"Property"}
          />
        )}
        <div className="search-input">
          <input
            onChange={(e) => {
              handleChangeFilter("search", e.target.value);
            }}
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "150px" }}
            value={selectedFilter.search}
          />
          <img src={Search_icon} className="search here" alt="" />
        </div>
      </div>
      {tabs === 1 ? (
        <MMCCancelRequest
          list={transactions.requested}
          setPage={setPage}
          pagination={pagination}
          page={page}
          setSelectedOwners={setSelectedOwners}
          selectedOwners={selectedOwners}
          setIsViewDetails={setIsViewDetails}
        />
      ) : (
        <MMCApproveList
          list={transactions.approved}
          setPage={setPage}
          pagination={pagination}
          page={page}
        />
      )}
      {showSubmitPopup && (
        <ReadNotificationPopup
          setSubmissionDescription={setSubmissionDescription}
          setShowSubmitPopup={setShowSubmitPopup}
          submissionDescription={submissionDescription}
          handleSumbit={handleSumbit}
        />
      )}
      {isViewDetails?.ispopUp ? (
        <UnReadNotificationPopup
          setIsViewDetails={setIsViewDetails}
          isViewDetails={isViewDetails}
        />
      ) : (
        <></>
      )}
    </div>
  );
};
export default MMCCancellationList;
